<template>
  <PageShell :active="active">
    <section class="text-page">
      <h1>{{ articles.title }}</h1>
      <div class="content" v-loading="loading">
        <div v-html="articles.content"></div>
      </div>
    </section>
  </PageShell>
</template>

<script>
import PageShell from '@/components/common/PageShell.vue'

export default {
  name: 'TextPage',
  components: {
    PageShell
  },
  data() {
    return {
      articles: {},
      loading: false
    }
  },
  mounted() {
    this.loadArticle()
  },
  watch: {
    '$route.query.id': function () {
      this.loadArticle()
    }
  },
  methods: {
    async loadArticle() {
      this.loading = true
      const id = this.$route.query.id || '4'
      try {
        const res = await this.$api({
          url: 'Content/articleDetail',
          method: 'get',
          data: { id: Number(id) }
        })
        this.articles = res.data || {}
      } catch (e) {
        // keep placeholder content on failure
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.text-page {
  max-width: 1100px;
  min-height: 900px;
  margin: 0 auto;
  padding: 34px 20px 80px;
}

h1 {
  margin: 0 0 34px;
  font-size: 28px;
  font-weight: 400;
}
</style>
